var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRanking5 = function SvgRanking5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.655 6.472H2.517V.33a.33.33 0 0 1 .33-.33h10.482a.33.33 0 0 1 .33.33v6.142h-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2CAD9",
    d: "M2.517 0h2.666v5.86H2.517V0zm4.25 0h2.637v5.86H6.768V0zm4.222 0h2.666v5.86H10.99V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5E3EB",
    d: "M.009 11.692a8.075 8.075 0 0 0 12.179 7.187 8.077 8.077 0 0 0 3.968-7.187 8.078 8.078 0 1 0-16.148 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2CAD9",
    d: "M2.078 11.692a6.008 6.008 0 1 0 12.016 0 6.008 6.008 0 0 0-12.016 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.063 15.159a2.703 2.703 0 0 1-1.957.725 2.828 2.828 0 0 1-1.997-.725 2.743 2.743 0 0 1-.735-1.908h1.944c.06.557.297.89.794.89a.687.687 0 0 0 .547-.215c.178-.177.25-.487.25-.988 0-.936-.329-1.2-.793-1.2a.772.772 0 0 0-.795.607H5.535V7.372h5.148v1.756H7.302v1.319c.339-.22.736-.335 1.14-.33.606-.03 1.2.183 1.648.593.688.689.784 1.447.784 2.241-.013 1.005-.152 1.585-.81 2.208z"
  }))));
};
export default SvgRanking5;